var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#00C853"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6611 6.00375L17.5024 6C15.0772 6 13.5099 7.73871 13.5099 10.4298V12.4723H11.3394C11.1519 12.4723 11 12.6367 11 12.8395V15.7988C11 16.0016 11.1521 16.1658 11.3394 16.1658H13.5099V23.633C13.5099 23.8358 13.6618 24 13.8493 24H16.6812C16.8687 24 17.0206 23.8356 17.0206 23.633V16.1658H19.5584C19.7459 16.1658 19.8978 16.0016 19.8978 15.7988L19.8989 12.8395C19.8989 12.7421 19.863 12.6489 19.7995 12.5799C19.7359 12.511 19.6493 12.4723 19.5593 12.4723H17.0206V10.7409C17.0206 9.90868 17.204 9.48622 18.2065 9.48622L19.6607 9.48566C19.8481 9.48566 20 9.32124 20 9.11863V6.37077C20 6.16835 19.8483 6.00412 19.6611 6.00375Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.69b46736fc644171dcbe71e3463682f1.svg";
export { ForwardRef as ReactComponent };